import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';

// Context
import { AuthProvider } from "./context/AuthContext";

// Components
import ProtectedRoute from "./components/ProtectedRoute";

// Auth Pages
import Login from "./pages/LoginPage";
import Register from "./pages/RegisterPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

// Protected Pages
import Dashboard from "./pages/Dashboard";
import InventoryPage from "./pages/InventoryPage";
import ProductPage from "./pages/ProductPage";
import OrderPage from "./pages/OrderPage";
import ReportsPage from "./pages/ReportsPage";
import Warehouse from "./pages/Warehouse";
import StockMovement from "./pages/Stockmovement";
import Suppliers from "./pages/Suppliers"
import TeamManagement from "./pages/TeamManagementPage";
import ProductTemplates from "./pages/ProductTemplates";
import QualityAssurance from "./pages/QualityAssurance";
import StockDashboard from "./pages/StockDashboard";
import AcceptInvitation from "./pages/AcceptInvitation";
import TestRoles from "./pages/TestRoles";

import PromptNavigator from "./PromptNavigator";
import CompanyAdmin from "./pages/CompanyAdmin";
import EmailVerification from "./pages/EmailVerification";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app-container">
          <div className="main-content full-width">
            <Routes>
              {/* Public Routes */}
              {/* <Route path="/Company-admin" element={<CompanyAdmin />} /> */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
             
              {/* Protected Routes - Require Authentication */}
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/inventory" 
                element={
                  <ProtectedRoute>
                    <InventoryPage />
                  </ProtectedRoute>
                } 
              />
                  <Route 
                path="/test-roles" 
                element={
                  <ProtectedRoute>
                    <TestRoles />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/products" 
                element={
                  <ProtectedRoute>
                    <ProductPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/warehouse" 
                element={
                  <ProtectedRoute>
                    <Warehouse />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/suppliers" 
                element={
                  <ProtectedRoute>
                    <Suppliers />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/orders" 
                element={
                  <ProtectedRoute>
                    <OrderPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/reports" 
                element={
                  <ProtectedRoute>
                    <ReportsPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/stock" 
                element={
                  <ProtectedRoute>
                    <StockMovement />
                  </ProtectedRoute>
                } 
              />
              
              {/* Admin-Only Route */}
              <Route 
                path="/team" 
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <TeamManagement />
                  </ProtectedRoute>
                } 
              />

              <Route 
                path="/templates" 
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <ProductTemplates />
                  </ProtectedRoute>
                } 
              />

              <Route 
                path="/quality-assurance" 
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <QualityAssurance />
                  </ProtectedRoute>
                } 
              />

              <Route 
                path="/stock-dashboard" 
                element={
                  <ProtectedRoute /*requireMerchandiser={true}*/>
                    <StockDashboard />
                  </ProtectedRoute>
                } 
              />

               {/* Super Admin Route - Company Management */}
              <Route 
                path="/company-admin" 
                element={
                  <ProtectedRoute requireSuperAdmin={true}>
                    <CompanyAdmin />
                  </ProtectedRoute>
                } 
              />

              <Route path="/verify-email" element={<EmailVerification />} />

              <Route path="/accept-invitation" element={<AcceptInvitation />} />

              {/* Default Route - Redirect to login */}
              <Route path="/" element={<Navigate to="/login" replace />} />
              
              {/* Catch all - Redirect to dashboard if authenticated, login if not */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
          <PromptNavigator />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;